module.exports = __webpack_public_path__ + "static/media/q02.e1a5a6fa.mp3";